<template>
        <div>
                      <div v-if="cls == 'coupon'" class="breadcrumb">
                        <div class="y1">
                          <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">{{$lang(50047)}}</el-breadcrumb-item>

                            <el-breadcrumb-item> {{$lang(50045)}} </el-breadcrumb-item>
                          </el-breadcrumb>
                        </div>
                      </div>

            <div v-if="cls == 'yygl'" class="breadcrumb">
                   <div class="y1">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }">{{$lang(50047)}}</el-breadcrumb-item>
                        <el-breadcrumb-item><a href="/">{{$lang(50048)}}</a></el-breadcrumb-item>
                        <el-breadcrumb-item>预约管理</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>

            <div v-if="cls == 'personal'" class="breadcrumb">
                <div class="y1">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }">{{$lang(50047)}}</el-breadcrumb-item>
                        <el-breadcrumb-item><a href="/">{{$lang(50048)}}</a></el-breadcrumb-item>
                        <el-breadcrumb-item>{{$lang(50049)}}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>

            <div v-if="cls == 'bus_list'" class="breadcrumb">
                <div class="y1">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }">{{$lang(50047)}}</el-breadcrumb-item>
                        <el-breadcrumb-item  :to="{ path: '/bus_list' }"> {{$lang(50048)}} </el-breadcrumb-item>
                        <el-breadcrumb-item>{{$lang(42433)}}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
            <div v-if="cls == 'ele_ticket'" class="breadcrumb">
                <div class="y1">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }">{{$lang(50047)}}</el-breadcrumb-item>
                        <el-breadcrumb-item><a href="/#/bus_list">{{$lang(42433)}}</a></el-breadcrumb-item>
                        <el-breadcrumb-item>电子票</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </div>


</template>

<script>
export default {
    name:"breadcrumb",
    props:['cls'],
    data(){
        return {

        };
    },
}
</script>
<style  scoped>
 .breadcrumb{
    margin-top: 2%;
    margin-left: 1%;
    width: 58vw;
    height:7vh;
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(108, 117, 125, 0.1);
    border-radius: 10px;
}
 .breadcrumb .y1{
    margin-top: 2.3%;
    margin-left: 3%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/breadcrumb.vue